// Contagem da revanche (canvas 4.10b): com o fundo escurecido, "REVANCHE" fixo em cima e 3, 2, 1 no centro, um por
// segundo, com um anel dourado que vai fechando; "VALENDO!" quando as cartas começam a sair. O número sai do prazo
// 'contagem' do servidor, igual nos 6 aparelhos. Tique a cada número (o som desligado não toca); com movimento
// reduzido, os números trocam sem animação.
import { useEffect, useRef, useState } from 'react';
import { agoraNoServidor, useAgora } from '../comum/useMesa.ts';
import { som } from '../som/som.ts';
import { movimentoReduzido } from './animacao.ts';
import type { EstadoMesa } from './conexao.ts';

export const CONTAGEM_MS = 3000;
const VALENDO_MS = 1200;

export function Contagem({ e }: { e: EstadoMesa }) {
  useAgora(100);
  const prazo = e.prazos.find((p) => p.tipo === 'contagem') ?? null;
  const resta = prazo ? prazo.ate - agoraNoServidor(e) : 0;
  const numero = prazo && resta > 0 ? Math.min(3, Math.ceil(resta / 1000)) : null;
  // A contagem que este aparelho mostrou: quando ela some e a partida começa, aparece o VALENDO!.
  const vista = useRef(false);
  const [valendo, setValendo] = useState(false);
  if (prazo) vista.current = true;
  useEffect(() => { if (numero !== null) som.tique(); }, [numero]);
  const comecou = e.sala?.fase === 'jogo';
  useEffect(() => {
    if (prazo || !comecou || !vista.current) return;
    vista.current = false;
    setValendo(true);
    const t = setTimeout(() => setValendo(false), VALENDO_MS);
    return () => clearTimeout(t);
  }, [!!prazo, comecou]);
  if (!prazo && !valendo) return null;
  const parado = movimentoReduzido(), volta = 2 * Math.PI * 52, falta = Math.max(0, Math.min(1, resta / CONTAGEM_MS));
  const texto = numero === null ? 'VALENDO!' : String(numero);
  return (
    <div className={'contagem-fundo' + (parado ? ' parado' : '')}>
      <div className="contagem-revanche" role="status" aria-live="assertive" aria-label={numero === null ? 'Valendo!' : `Revanche em ${numero}`}>
        <h2>REVANCHE</h2>
        <div className="anel-contagem">
          <svg viewBox="0 0 120 120" aria-hidden="true">
            <circle className="trilho" cx="60" cy="60" r="52" />
            <circle className="arco" cx="60" cy="60" r="52" strokeDasharray={volta} strokeDashoffset={volta * (1 - falta)} />
          </svg>
          <b key={texto} className={numero === null ? 'valendo' : ''}>{texto}</b>
        </div>
      </div>
    </div>
  );
}
